import { range } from 'lodash';
import { hosts } from 'settings';
import { yearDigits } from 'utils/timeFormat';

export const SIGNUP_TYPES = ['program', 'bundle', 'nutrition', 'workouts'];
export const SIGNUP_MONTHS = range(1, 13);
export const SIGNUP_YEARS = range(yearDigits, yearDigits + 11);
export const SIGNUP_IS_DEV = process.env.NODE_ENV === 'development';
export const SIGNUP_REDIRECT_URI = `${hosts.go}/sign-up/verify`;
export const CREDIT_CARD_REDIRECT_URI = `${
  hosts.go
}/profile/credit-card/verify`;

export const SIGNUP_TEXT = {
  program: {
    title: 'Purchase a Coaching Zone Program',
    discountText:
      'Use your Coaching Zone Nutrition or Coaching Zone Workouts login and receive <strong>15%</strong> off.',
    discountApplied: 'Coaching Zone member discount applied.',
    firstPaymentInDays: 0,
    included: [
      'Yours to keep',
      'Start anytime',
      'Exercise and nutrition',
      'Designed by experts',
    ],
  },

  weekly: {
    title: 'Sign up to Coaching Zone',
    byline: 'First week free. No contract, cancel any time.',
    firstPaymentInDays: 7,
    included: [
      'First week free',
      'No contract, cancel any time',
      'Huge library of recipes and workouts',
      'Weekly insights from our expert team',
      'From the same team that brought you 12WBT',
    ],
    'Coaching Zone Workouts': {
      abbrev: 'Wo',
      icon: 'icon-workouts',
      byline: 'Workouts with a side of nutrition',
      bundle: 'Add Coaching Zone Nutrition and save 25%.',
      color: 'teal-dark',
    },
    'Coaching Zone Nutrition': {
      abbrev: 'Nu',
      icon: 'icon-recipes',
      byline: 'Nutrition with a side of workouts',
      bundle: 'Add Coaching Zone Workouts and save 25%.',
      color: 'green-mid',
    },
  },
};

export const SIGNUP_TEXT_COUPON = {
  MPORT: {
    ...SIGNUP_TEXT.weekly,
    firstPaymentInDays: 31,
    couponTitle: 'mPort',
    couponTermsUri: 'https://mport.com/terms-and-conditions.html',
    included: [
      '<strong>Get 1 month free</strong>',
      ...SIGNUP_TEXT.weekly.included.slice(1),
    ],
  },

  NIMBLE: {
    ...SIGNUP_TEXT.weekly,
    firstPaymentInDays: 31,
    couponTitle: 'Nimble',
    couponTermsUri: 'https://nimbleactivewear.com/pages/terms',
    included: [
      '<strong>Get 1 month free</strong>',
      ...SIGNUP_TEXT.weekly.included.slice(1),
    ],
  },

  'SUPER-BUNDLE': {
    ...SIGNUP_TEXT.weekly,
    couponTitle: 'super-bundle',
  },

  'PROGRAM-UPGRADE': {
    ...SIGNUP_TEXT.weekly,
    couponTitle: 'program-upgrade',
  },
};

export const SIGNUP_REDIRECT_LIST = ['PROGRAM-UPGRADE'];

// Chargify Parameters
// https://developer.chargify.com/content/chargify-direct/overview.html#resource-parameters
export const SIGNUP_FIELDS_SECURE = {
  apiId: 'secure[api_id]',
  timestamp: 'secure[timestamp]',
  nonce: 'secure[nonce]',
  data: 'secure[data]',
  signature: 'secure[signature]',
};

// Fields required for sign up
export const SIGNUP_FIELDS = {
  ...SIGNUP_FIELDS_SECURE,
  email: 'signup[customer][email]',
  firstName: 'signup[customer][first_name]',
  lastName: 'signup[customer][last_name]',
  cardNumber: 'signup[payment_profile][card_number]',
  expirationMonth: 'signup[payment_profile][expiration_month]',
  expirationYear: 'signup[payment_profile][expiration_year]',
};

// Fields required for updating credit card
export const CREDIT_CARD_FIELDS = {
  ...SIGNUP_FIELDS_SECURE,
  cardNumber: 'payment_profile[card_number]',
  expirationMonth: 'payment_profile[expiration_month]',
  expirationYear: 'payment_profile[expiration_year]',
};

// Chargify Error Codes
// https://developer.chargify.com/content/chargify-direct/overview.html#result-codes
export const CHARGIFY_ERROR_CODES = {
  4000: 'Submission error',
  4001: 'Authentiction failed',
  4011: 'Authentication failed due to missing nonce value',
  4040: 'The requested subscription could not be found',
  4220: 'One or more validation errors on input',
  4221: 'Duplicate submission',
  4300: 'Card declined',
  5000: 'An error has occured',
  5001: 'The requested resource does not exist',
  5002: 'Verification error',
};



// WEBPACK FOOTER //
// ./src/constants/Signup.js